// src/blocks/move/moveRight.ts

import * as Blockly from 'blockly';
import { javascriptGenerator } from 'blockly/javascript';
import { BlocklyFields } from '../../BlocklyFields';
import i18next from 'i18next';

export function initMoveUpRightBlock() {

    Blockly.Blocks[BlocklyFields.MOVE_UPRIGHT] = {
        init: function () {
            this.jsonInit({
                "type": BlocklyFields.MOVE_UPRIGHT,
                "message0": '%1 ' + i18next.t('blockly.diagonal.upright.message', 'Move up right'),
                "args0": [
                    {
                        "type": "field_image",
                        "src": "/images/blocks/upright.png", // Lien vers votre icône (chemin relatif ou absolu)
                        "width": 16,   // Largeur de l'image
                        "height": 16,  // Hauteur de l'image

                    }
                ],
                "previousStatement": null,
                "nextStatement": null,
                "colour": '#9966FF',
                "tooltip": i18next.t('blockly.diagonal.upright.message', ''),
                "helpUrl": ""
            });
        },
    };

    javascriptGenerator.forBlock[BlocklyFields.MOVE_UPRIGHT] = function (block, generator) {
        return 'await walkCharacter(315);\n';
    }
}
